<template>
    <li class="nav-item w-100">
        <router-link :to="to" @click.native="linkClick" class="nav-link d-flex align-items-center">
            <template>
                <i :class="`${icon} fa-xs`" style="color: #9ea4aa"></i>
                <span class="nav-link-text">{{ label }}</span>
            </template>
        </router-link>

    </li>

</template>
<script>
  export default {
    name: 'sidebar-item',
    props: {
      label: { },
      icon: { },
      to: { },
      color: {
        type: String,
        default: 'default',
      },
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        children: [],
        collapsed: true
      };
    },
    methods: {
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>

<style scoped>
  .nav-item span {
    color: #fff !important;
    font-weight: 400; 
    font-size: 15.4px
  }
</style>
